import { render, staticRenderFns } from "./AzComboEnumPaginado.vue?vue&type=template&id=51ed4e58"
import script from "./AzComboEnumPaginado.vue?vue&type=script&lang=js"
export * from "./AzComboEnumPaginado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports